import React from 'react'
import { HelpModal } from '../../help/help-modal.component'

export const RemedialCoursesHelp = ({modalRef}) =>
  <HelpModal innerRef={modalRef} title='It affects the requirements for TAP'>
    Students who have to take 2 or more developmental/remedial courses have different academic requirements.
  </HelpModal>